import React, { useState } from 'react';
import Axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const HclSatheeReports = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(false);
    const [reportType, setReportType] = useState('students');
    const [sortBy, setSortBy] = useState('registration_date');
    const [filters, setFilters] = useState({
        state: '', district: '', school: '', gender: '', socialGroup: '', class: '', exam: '', startDate: '', endDate: ''
    });

    const handleChange = e => setFilters({ ...filters, [e.target.name]: e.target.value });

    const handleDownload = async () => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams({ ...filters, sortBy }).toString();
            let endpoint = '';
            if (reportType === 'students') endpoint = '/sathee/reports/download';
            else if (reportType === 'assessments') endpoint = '/sathee/reports/assessments/download';
            else if (reportType === 'combined') endpoint = '/sathee/reports/combined/download';
            else endpoint = '/sathee/reports/kendras/download';
            const res = await Axios.get(`${API_URL}${endpoint}?${queryParams}`, { 
                headers: { Authorization: localStorage.getItem('token') },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement('a');
            a.href = url;
            let prefix = 'HCL_Sathee_Report_';
            if (reportType === 'students') prefix = 'HCL_Sathee_Students_Report_';
            else if (reportType === 'assessments') prefix = 'HCL_Sathee_Assessments_Report_';
            else if (reportType === 'combined') prefix = 'HCL_Sathee_Combined_Report_';
            else prefix = 'HCL_Sathee_Kendras_Report_';
            a.download = `${prefix}${new Date().toISOString().split('T')[0]}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            toast.success('Download started!');
        } catch (err) {
            toast.error('Failed to download reports');
        }
        setLoading(false);
    };

    const IStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box' };

    return (
        <div style={{ padding: 20 }}>
            <ToastContainer />
            <h2 style={{ marginBottom: 20 }}>Advanced Reports & Exports</h2>
            <div style={{ background: '#fff', padding: 20, borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.05)', marginBottom: 30 }}>
                <h4 style={{ marginBottom: 15, color: '#4a5568' }}>Filter Data</h4>
                
                <div style={{ display: 'flex', gap: 20, marginBottom: 20, paddingBottom: 20, borderBottom: '1px solid #eee' }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontWeight: 'bold', color: '#111' }}>Report Type</label>
                        <select style={IStyle} value={reportType} onChange={e => setReportType(e.target.value)}>
                            <option value="students">Student Registration</option>
                            <option value="assessments">Assessment Details</option>
                            <option value="combined">Combined Students & Assessments</option>
                            <option value="kendras">Kendra Details</option>
                        </select>
                    </div>
                    {reportType !== 'kendras' && (
                        <div style={{ flex: 1 }}>
                            <label style={{ fontWeight: 'bold', color: '#111' }}>Sort By</label>
                            <select style={{ ...IStyle, background: '#f9fafb' }} value={sortBy} onChange={e => setSortBy(e.target.value)}>
                                <option value="registration_date">Registration Date (Newest)</option>
                                <option value="highest_marks">Highest Post-Marks (Ranking)</option>
                                <option value="highest_improvement">Highest Improvement</option>
                            </select>
                        </div>
                    )}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 15 }}>
                    <div>
                        <label>State</label>
                        <input style={IStyle} name="state" placeholder="e.g. Rajasthan" value={filters.state} onChange={handleChange} />
                    </div>
                    <div>
                        <label>District</label>
                        <input style={IStyle} name="district" value={filters.district} onChange={handleChange} />
                    </div>
                    {reportType === 'students' && (
                        <>
                            <div>
                                <label>School Name</label>
                                <input style={IStyle} name="school" value={filters.school} onChange={handleChange} />
                            </div>
                            <div>
                                <label>Gender</label>
                                <select style={IStyle} name="gender" value={filters.gender} onChange={handleChange}>
                                    <option value="">All</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div>
                                <label>Social Group</label>
                                <select style={IStyle} name="socialGroup" value={filters.socialGroup} onChange={handleChange}>
                                    <option value="">All</option>
                                    <option value="General">General</option>
                                    <option value="EWS">EWS</option>
                                    <option value="OBC">OBC</option>
                                    <option value="SC">SC</option>
                                    <option value="ST">ST</option>
                                </select>
                            </div>
                            <div>
                                <label>Class</label>
                                <input style={IStyle} name="class" value={filters.class} onChange={handleChange} />
                            </div>
                            <div>
                                <label>Exam</label>
                                <select style={IStyle} name="exam" value={filters.exam} onChange={handleChange}>
                                    <option value="">All</option>
                                    <option value="JEE">JEE</option>
                                    <option value="NEET">NEET</option>
                                    <option value="CUET">CUET</option>
                                    <option value="Board Exam">Board Exam</option>
                                </select>
                            </div>
                        </>
                    )}
                    <div>
                        <label>From Date</label>
                        <input type="date" style={IStyle} name="startDate" value={filters.startDate} onChange={handleChange} />
                    </div>
                    <div>
                        <label>To Date</label>
                        <input type="date" style={IStyle} name="endDate" value={filters.endDate} onChange={handleChange} />
                    </div>
                </div>

                <div style={{ marginTop: 25, textAlign: 'right' }}>
                    <button onClick={handleDownload} disabled={loading} style={{ padding: '12px 24px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                        <i className="bx bx-download" style={{ marginRight: 5 }}></i> {loading ? 'Processing...' : 'Download Excel'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HclSatheeReports;
